import { IPublicClientApplication } from "@azure/msal-browser";
import Button from "@mui/material/Button";
import { loginRequest } from "../../config/AuthConfig";
import Image from "../../assets/img/bgRIO.jpg";
import { Box, CssBaseline } from "@mui/material";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

type pageProps = {
  instance: IPublicClientApplication;
  autoSignOn?: boolean;
};

const loginStyle = {
  width: "100",
  height: "100vh",
  backgroundImage: `url(${Image})`,
  backgroundSize: "cover",
  margin: 0,
  border: 0,
};

const LoginPage = (props: pageProps) => {

  const handleLogin = () => {
    props.instance.loginRedirect(loginRequest).catch((e) => {
      console.error(e);
    });
  };

  return (
    <Box style={loginStyle}>
      <CssBaseline />
      <div
        style={{
          width: "20%",
          minHeight: "15%",
          marginTop: "10%",
          position: 'absolute',
          lineHeight: "30px",
          marginLeft: "20%",
          backgroundColor: "#F5F5F5",
          textAlign: "center",
          alignItems: "centre",
        }}
      >
        <h1 style={{ padding: '10%', fontSize: '1.5em' }}>
          Unity Data Lake (UDL)
      </h1>

        <Button id="bbb15563-8b0e-4df1-8c76-ef6b808f83bb"
          style={{
            // minHeight: "10%",
          }}
          variant="contained"
          className="ml-auto"
          onClick={() => handleLogin()}
          size="large"
          endIcon={<ChevronRightIcon />}
        >
          Sign in with SSO
      </Button>
        {!props.autoSignOn ? <p style={{ paddingTop: '1%' }}>You have been signed out due to inactivity or you are not subscribed to IDP Users production.</p> : ''}

        <h4 style={{ padding: '10%', paddingTop: '3%' }}>
          Subscribe to IDP Users Production {' '}
          <a href="http://groupsubscription.riotinto.org/">here</a>
        </h4>
      </div>
    </Box>
  );
};

export default LoginPage;
